import { atom } from 'recoil';

import { UI } from 'store/constants';

export const AUI = atom<boolean>({
  key: UI,
  default: true,
});
